module.exports = __webpack_public_path__ + "img/SPEDIMO_logo_white.9c936b89.svg";